import React from 'react';
import { ShoppingCart, GitHub } from 'react-feather';

const Footer: React.FC = () => {
    return (
        <footer className="bg-gray-900 text-white py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-4 gap-8">
                    <div>
                        <div className="flex items-center mb-4">
                            <ShoppingCart className="h-8 w-8 text-green-400" />
                            <span className="ml-2 text-xl font-bold text-green-400">Le Panier Clair</span>
                        </div>
                        <p className="text-gray-400">
                            Vous aider à faire des choix plus sains et durables depuis 2025.
                        </p>
                    </div>
                    
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Navigation</h3>
                        <ul className="space-y-2">
                            <li><a href="/" className="text-gray-400 hover:text-green-400 transition">Accueil</a></li>
                            <li><a href="/#features-section" className="text-gray-400 hover:text-green-400 transition">Fonctionnalités</a></li>
                            <li><a href="/#how-it-works-section" className="text-gray-400 hover:text-green-400 transition">Comment ça marche</a></li>
                            <li><a href="/#download-section" className="text-gray-400 hover:text-green-400 transition">Télécharger</a></li>
                        </ul>
                    </div>
                    
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Légal</h3>
                        <ul className="space-y-2">
                                <li><a href="/privacy-policy" className="text-gray-400 hover:text-green-400 transition">Politique de confidentialité</a></li>
                            <li><a href="/terms-of-use" className="text-green-400 font-medium">Conditions d’utilisation</a></li>
                        </ul>
                    </div>
                    
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Contact</h3>
                        <div className="flex space-x-4 mb-4">
                            <a href="https://github.com/4ntoninFille/PanierClair" className="text-gray-400 hover:text-green-400 transition"><GitHub /></a>
                        </div>
                        <p className="text-gray-400">
                            Une question ? <a href="mailto:contact@panierclair.fr" className="text-green-400 hover:underline">contact@panierclair.fr</a>
                        </p>
                    </div>
                </div>
                
                <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500 text-sm">
                    <p>© 2025 Le Panier Clair. Tous droits réservés. OpenFoodFacts est une marque déposée de l’association Open Food Facts.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;